import { createFileRoute, notFound } from '@tanstack/react-router';

import { Notification } from '@mint-lib/icons';
import {
  buildGuards,
  hasPermission,
  isAgencyCompany,
  isControllerCompany,
  isRetailLicensee,
  not,
} from '@mint-lib/routing-guards';

const guard = buildGuards(
  hasPermission('notificationsFeature:view'),
  not(isAgencyCompany),
  not(isControllerCompany),
  not(isRetailLicensee),
);

// TODO(STZF-23): fix guard duplication with sidebar in permissions refactoring
const sidebarGuard = buildGuards(
  hasPermission('notificationsFeature:view'),
  not(isAgencyCompany),
);

export const Route = createFileRoute('/_secured/notifications/')({
  staticData: {
    commandMeta: ({ t, check }) => {
      // TODO(STZF-23): route and sidebar guards differ; merge them into one guard in permissions refactoring
      if (!check(guard) || !check(sidebarGuard)) {
        return;
      }

      return {
        title: t('Notifications'),
        keywords: [t('alerts')],
        icon: Notification,
      };
    },
  },
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext();
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  async loader({ context }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');

    await Promise.all([
      context.getInstance('i18n', '@myn/notifications-hub'),
      context.getInstance('i18n', '@mint-lib/ai-chat'),
      context.getInstance('i18n', '@mint-lib/tw-components'),
      context.getInstance('i18n', '@mint-lib/formatting-hooks'),
    ]);

    return {
      isReadOnly: !(await context.hasPermission('notificationsFeature:modify')),
      title: i18n.t('Notifications Hub | MINT'),
    };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
